import { momentFormat, calcUpload } from '@/utils'
// 工作台-预约-主列表
export const AppointColumns = [
  {
    title: '预约编号',
    key: 'reserveSn',
    dataIndex: 'reserveSn',
    width: 120
  },
  {
    title: '医生姓名',
    key: 'doctorName',
    dataIndex: 'doctorName',
    width: 80
  },
  {
    title: '就诊人姓名',
    key: 'patientName',
    dataIndex: 'patientName',
    width: 80,
    customRender: ({ record }) => {
      return record.patientProfileCommonVO?.patientProfileName || '--'
    }
  },
  {
    title: '就诊医院',
    key: 'hospitalName',
    dataIndex: 'hospitalName',
    width: 100
  },
  {
    title: '就诊科室',
    key: 'department',
    dataIndex: 'department',
    width: 100
  },
  {
    title: '预约就诊时间',
    key: 'reserveDate',
    dataIndex: 'reserveDate',
    width: 100,
    slots: {
      customRender: 'reserveDate'
    }
  },
  {
    title: '预约类型',
    key: 'revisitType',
    dataIndex: 'revisitType',
    width: 100,
    slots: {
      customRender: 'revisitType'
    }
  },
  {
    title: '状态',
    key: 'reserveState',
    dataIndex: 'reserveState',
    width: 100,
    slots: {
      customRender: 'reserveState'
    }
  },
  {
    title: '复诊跟踪AI电话创建',
    key: 'followupTrackAiCallFlag',
    dataIndex: 'followupTrackAiCallFlag',
    width: 110,
    slots: {
      customRender: 'followupTrackAiCallFlag'
    }
  },
  {
    title: '创建时间',
    key: 'createdAt',
    dataIndex: 'createdAt',
    width: 140
  },
  {
    title: '操作',
    key: 'operation',
    fixed: 'right',
    width: 100,
    slots: {
      customRender: 'operation'
    }
  }
]

// 工作台-预约-主列表
export const opeartColumns = [
  {
    title: '发起时间',
    key: 'department',
    dataIndex: 'department',
    width: 120
  },
  {
    title: '编辑人',
    key: 'department',
    dataIndex: 'department',
    width: 120
  },
  {
    title: '更新聊天记录',
    key: 'department',
    dataIndex: 'department',
    width: 120
  },
  {
    title: '更新小结内容',
    key: 'department',
    dataIndex: 'department',
    width: 120
  }
]

export const SummaryColumns = [
  {
    title: '小结编号',
    key: 'chatSummaryId',
    dataIndex: 'chatSummaryId',
    width: 150
  },
  {
    title: '就诊人姓名',
    key: 'patientName',
    width: 120,
    dataIndex: 'patientName',
    customRender: ({ record }) => {
      return record.patientProfileCommonVO?.patientProfileName || '--'
    }
  },
  {
    title: '医生姓名',
    key: 'doctorName',
    width: 120,
    dataIndex: 'doctorName'
  },
  {
    title: '添加人',
    key: 'createByName',
    width: 120,
    dataIndex: 'createByName'
  },
  {
    title: '添加时间',
    key: 'createdAt',
    width: 120,
    dataIndex: 'createdAt'
  },
  {
    title: '小结来源',
    dataIndex: 'type',
    key: 'type',
    width: 120,
    customRender: ({ text }) => {
      const belongType = TYPE.filter(item => item.value === text)
      return SOURCE_TYPE[belongType[0]?.belong]
    }
  },
  {
    title: '小结内容',
    key: 'contents',
    width: 220,
    dataIndex: 'contents',
    slots: {
      customRender: 'contents'
    }
  },
  {
    title: '关联工单',
    key: 'workOrderIds',
    width: 220,
    dataIndex: 'workOrderIds',
    slots: {
      customRender: 'workOrderIds'
    }
  },
  {
    title: '发送群聊',
    key: 'pushStatus',
    width: 120,
    slots: {
      customRender: 'pushStatus'
    },
    dataIndex: 'pushStatus'
  },
  {
    title: '操作',
    key: 'operation',
    fixed: 'right',
    width: 200,
    slots: {
      customRender: 'operation'
    }
  }
]

export const SummaryLogColumns = [
  {
    title: '创建时间',
    key: 'createAt',
    dataIndex: 'createAt',
    width: 150,
    customRender: ({ record }) => {
      const { firstUpdate, createAt } = record
      return firstUpdate ? createAt : '--'
    }
  },
  {
    title: '创建人',
    key: 'name',
    dataIndex: 'name',
    width: 150,
    customRender: ({ record }) => {
      const { firstUpdate, name } = record
      return firstUpdate ? name : '--'
    }
  },
  {
    title: '编辑时间',
    key: 'createAt',
    dataIndex: 'createAt',
    width: 150,
    customRender: ({ record }) => {
      const { firstUpdate, createAt } = record
      return firstUpdate ? '--' : createAt
    }
  },
  {
    title: '操作人',
    key: 'name',
    dataIndex: 'name',
    width: 150,
    customRender: ({ record }) => {
      return record.name
    }
  },
  {
    title: '编辑内容',
    key: 'contents',
    width: 220,
    dataIndex: 'contents',
    slots: {
      customRender: 'contents'
    }
  }
]

export const columnsMedicalRecords = [
  {
    title: '操作',
    key: 'isSendRecord',
    fixed: 'left',
    width: 60,
    slots: {
      customRender: 'isSendRecord'
    }
  },
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 115,
    fixed: 'left'
  },
  {
    title: '患者姓名',
    dataIndex: 'patientName',
    key: 'patientName',
    width: 104
  },
  {
    title: '就诊时间',
    dataIndex: 'inquiryTime',
    key: 'inquiryTime',
    width: 104,
    customRender: ({ text }) => {
      return momentFormat(text)
    }
  },
  // {
  //   title: '就诊医院',
  //   dataIndex: 'offlineHospital',
  //   key: 'offlineHospital',
  //   width: 104
  // },
  // {
  //   title: '就医科室',
  //   dataIndex: 'offlineDepartment',
  //   key: 'offlineDepartment',
  //   width: 104
  // },
  // {
  //   title: '就诊医生',
  //   dataIndex: 'offlineDoctor',
  //   key: 'offlineDoctor',
  //   width: 104
  // },
  {
    title: '就医诊断',
    dataIndex: 'offlineDiagnosis',
    key: 'offlineDiagnosis',
    width: 150,
    slots: { customRender: 'offlineDiagnosis' }
  },
  {
    title: '处方药品',
    dataIndex: 'medicationNames',
    key: 'medicationNames',
    width: 150,
    slots: { customRender: 'medicationNames' }
  },
  {
    title: '开始时间',
    dataIndex: 'beginTime',
    key: 'beginTime',
    width: 120
  },
  {
    title: '用药周期',
    dataIndex: 'medicineCycle',
    key: 'medicineCycle',
    width: 120
  },
  {
    title: '结束时间',
    dataIndex: 'endTime',
    key: 'endTime',
    width: 120
  },
  // {
  //   title: '是否患者可见',
  //   dataIndex: 'patientPermission',
  //   key: 'patientPermission',
  //   width: 120
  // },
  {
    title: '上传人',
    dataIndex: 'createBy',
    key: 'createBy',
    width: 150,
    customRender: ({ record }) => {
      return calcUpload(record, 'createBy')
    }
  },
  {
    title: '上传时间',
    dataIndex: 'createAt',
    key: 'createAt',
    width: 120
  }
]

export const excellentCaseColumns = [
  {
    title: 'ID',
    key: 'excellentCaseId',
    dataIndex: 'excellentCaseId',
    width: 100
  },
  {
    title: '工单ID',
    key: 'workOrderId',
    dataIndex: 'workOrderId',
    slots: {
      customRender: 'workOrderId'
    }
  },
  {
    title: '工单类型',
    dataIndex: 'workOrderTypeName',
    key: 'workOrderTypeName'
  },
  {
    title: '健管',
    dataIndex: 'daName',
    key: 'daName'
  },
  {
    title: '上传人',
    dataIndex: 'createdByName',
    key: 'createdByName'
  },
  {
    title: '上传时间',
    key: 'createdAt',
    dataIndex: 'createdAt'
  },
  {
    title: '审核状态',
    key: 'auditStatus',
    dataIndex: 'auditStatus',
    slots: {
      customRender: 'auditStatus'
    }
  },
  {
    title: '审核完成时间',
    key: 'auditTime',
    dataIndex: 'auditTime'
  },
  {
    title: '宣广处',
    key: 'dptName',
    dataIndex: 'dptName'
  },
  {
    title: '分公司',
    key: 'branchCompanyName',
    dataIndex: 'branchCompanyName'
  },
  {
    title: '大区',
    key: 'majorAreaName',
    dataIndex: 'majorAreaName'
  },
  {
    title: '操作',
    key: 'handle',
    width: 220,
    dataIndex: 'handle',
    slots: {
      customRender: 'handle'
    }
  }
]

export const SOURCE_TYPE = {
  1: '预问诊',
  2: 'AI生成',
  3: '虚拟电话',
  4: '医助创建'
}

export const TYPE = [
  { value: 0, label: '普通小结', belong: 4 },
  { value: 1, label: '导诊结果', belong: 2 },
  { value: 2, label: '处方待购', belong: 2 },
  { value: 3, label: 'AI引导问诊小结', belong: 1 },
  { value: 4, label: '复诊跟踪', belong: 2 },
  { value: 5, label: '复诊提醒', belong: 2 },
  { value: 6, label: '患者私聊', belong: 2 },
  { value: 7, label: '复诊日期不同意', belong: 2 },
  { value: 8, label: '填写诊断及复诊日期', belong: 2 },
  { value: 9, label: '填写意图用药', belong: 2 },
  { value: 10, label: '通话记录', belong: 3 },
  { value: 12, label: '疗效跟踪', belong: 2 },
  { value: 13, label: '疗效反馈', belong: 2 }
]
